import { useStore } from '@/hooks/store/useStore';

type EmailType = {
  sender_name: string;
  sender_email: string;
};

type Emails = {
  general_contact_email: EmailType;
  sales_representative_email: EmailType;
  customer_support_email: EmailType;
  custom_email_one: EmailType;
  custom_email_two: EmailType;
};

export function useStoreEmails(type: keyof Emails) {
  const store = useStore();

  return store.emails?.[type];
}
